import React, { useState, useEffect } from 'react';

const Hero = () => {
  const images = [
    'https://100billion.in/client_images/4.png',
    'https://100billion.in/client_images/2.png',
    'https://100billion.in/client_images/3.png',
    'https://100billion.in/client_images/4.png',
    'https://100billion.in/client_images/1.png'
  ];

  const messages = [
    "Search your dream home...",
    "Search in Gurugram & Noida...",
    "Grab your dream with Gap Reality."
  ];

  // Search Bar State
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  // Background Slider State
  const [currentSlide, setCurrentSlide] = useState(0);

  // Search Bar Effect
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); 
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length);
        setFade(true);
      }, 500);
    }, 3000);
    return () => clearInterval(interval);
  }, [messages.length]);

  // Background Slider Effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="hero-container">
      {/* Background Slider */}
      {images.map((img, idx) => (
        <div
          key={idx}
          className={`hero-slide ${idx === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}

      {/* Overlay Content */}
      <div className="hero-overlay">
        <div className="search-container">
          <div className="moving-ring"></div>
          <input 
            type="text" 
            placeholder={messages[index]} 
            className={`search-input ${fade ? 'fade-in' : 'fade-out'}`}
          />
          <button className="search-button">Search</button>
        </div>
      </div>
    </div>
  );
}; // <--- THIS WAS MISSING

export default Hero;